import { compose, prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';
import { hasCampaignAllowedSetPrintProcess } from './utils';

const getRoot = prop(NAME);

export const getCampaignDetail = compose(prop('campaignDetail'), getRoot);
export const getCampaignId = compose(prop('id'), prop('campaignDetail'), getRoot);

export const getAllowSetPrint = createSelector(getCampaignDetail, hasCampaignAllowedSetPrintProcess);
